<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont el-icon-setting"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">开发告警</div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
            <div>
                <div class="btn btn_active" @click="loadData" style="float:  right; margin-bottom: 10px"><i class="iconfont icon-shuaxin"></i><span>{{ $t('ems.history.refresh') }}</span></div>
            </div>
            <el-table
                    :data="list"
                    style="width: 100%"
                    v-loading="listLoading"
                    border
                    size="small"
                    :height="700"
                    class="BMSTable"
            >
                <el-table-column  :label="$t('ems.alarm.describe')" prop="alarmName" sortable="custom" align="center">
                    <template slot-scope="scope">
                        <span v-if="language === 'zh'" >{{ scope.row.alarmName }}</span>
                        <span v-else >{{ scope.row.alarmNameEn  ? scope.row.alarmNameEn : scope.row.alarmName}}</span>
                    </template>
                </el-table-column>
                <el-table-column  :label="$t('ems.alarm.level')" sortable="custom" align="center" width="120" prop="alarmLevel">
                    <template slot-scope="scope">
                        <span v-if="scope.row.alarmLevel == 1" :style="{color: 'rgb(68, 209, 234)'}">{{ scope.row.alarmLevel |  alarmLevelF }}</span>
                        <span v-if="scope.row.alarmLevel == 2" :style="{color: 'rgb(255, 192, 0)'}">{{ scope.row.alarmLevel |  alarmLevelF }}</span>
                        <span v-if="scope.row.alarmLevel == 3" :style="{color: 'rgb(192, 0, 0)'}">{{ scope.row.alarmLevel |  alarmLevelF }}</span>
                    </template>
                </el-table-column>
                <el-table-column  :label="$t('ems.alarm.DeviceName')" prop="deviceAlias"  align="center" width="130"></el-table-column>
                <el-table-column  :label="$t('ems.alarm.EquipmentSerialNumber')"  prop="deviceNo" sortable="custom" align="center" width="200"></el-table-column>
                <el-table-column  :label="$t('ems.alarm.TimeofOccurrence')" prop="firstAlarmTime" sortable="custom" align="center" width="160"></el-table-column>
                <el-table-column  :label="$t('ems.alarm.Theprocessingtime')" prop="handlerTime" sortable="custom" align="center" width="160"></el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                        class="pagePagination"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        layout="total, sizes, prev, pager, next,jumper"
                        :page-size="size"
                        :page-sizes="[ 15, 50, 100 ]"
                        :current-page.sync="page"
                        :total="total"
                        popper-class="selectDown"
                ></el-pagination>
                <!--                popper-class-->
            </div>
        </div>

    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { getEmsctrlAlarm }from "@/api/spms";
    import i18n from "@/lang";
    export default {
        name: "DevAlarmSys",
        data(){
            return{
                opacity: 0,
                loading: false,
                form: {
                },
                listLoading: false,
                list: [],
                size: 15,
                page: 1,
                total:0,
            }
        },
        computed: {
            ...mapGetters(["language"]),
        },
        filters: {
            nullFormat(val){
                if(val === null || val === undefined){
                    return "--"
                }else {
                    return val
                }
            },
            confirmStatusF(val){
                switch (val) {
                    case 0:
                        return i18n.t("ems.alarm.new");
                    case 1:
                        return i18n.t("ems.alarm.confirm");
                    case 2:
                        return i18n.t("ems.alarm.remove");
                    case 3:
                        return i18n.t("ems.alarm.restore");
                    default:
                        return ""
                }
            },
            alarmLevelF(val){
                switch (val) {
                    case 1:
                        return i18n.t("ems.alarm.Level1");
                    case 2:
                        return i18n.t("ems.alarm.Level2");
                    case 3:
                        return i18n.t("ems.alarm.Level3");
                    default:
                        return ""
                }
            },
            systemTypeF(val){
                switch (val) {
                    case "CN":
                        return i18n.t("ems.alarm.EnergyStorage");
                    case "GF":
                        return i18n.t("ems.alarm.Photovoltaic");
                    case "FZ":
                        return i18n.t("ems.alarm.ControllableLoad");
                    case "BKKFZ":
                        return i18n.t("ems.alarm.UncontrolledLoad");
                    case "SD":
                        return i18n.t("ems.alarm.mains");
                    case "FD":
                        return i18n.t("ems.alarm.PowerGeneration");
                    default:
                        return ""
                }
            },
        },
        mounted(){
            setTimeout(() => {
                this.opacity = 1;
            },200);
            this.loadData();
        },
        methods: {
            loadData(){
                this.listLoading = true;
                getEmsctrlAlarm({size: this.size, current: this.page }).then(res => {
                    this.listLoading = false;
                    this.total = res.data.data.total;
                    this.list = res.data.data.records;
                }).catch(err => {
                    this.listLoading = false;
                    console.log(err)
                });
            },
            handleSizeChange(val) {
                this.page = 1;
                this.size = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.loadData();
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/site";
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
            .navRight{
                position: absolute;
                height: 100%;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                .creatTime{
                    font-size: 18px;
                    color: $_191_191_191;
                    margin-right: 40px;
                    span{
                        padding-left: 20px;
                        color: $font_bright_blue_title
                    }
                }
                .btn{
                    height: 30px;
                    width: 85px;
                    border: $font_bright_blue_title solid 2px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    color: $font_bright_blue_title;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    i{
                        margin-right: 5px;
                        font-size: 18px;
                    }
                }
            }
        }
        .content{
            padding: 20px;
            overflow: hidden;

            .table_header {
                margin-top: 20px;
                height: 30px;
                margin-bottom: 20px;
            }
            .page{
                margin-top: 20px;
                height: 30px;
            }
            .strategy_main {
                height: 780px;
            }
        }
    }
</style>